'use strict';

// Localisations
// ============
module.exports = {
  en: {
    title: 'Users',
    deletemessage: 'The delete user and user index api routes are restricted to users with the \'admin\ role.',
    groupstitle: 'All Groups',
    groupsmessage: 'Add uncategorised uses to groups.',
    unassignedusers: 'Unassigned Users',
    unassignedmessage: 'Add unassigned users to existing group (with add user button) or create new group by selecting multiple users and clicking create.',
    create: 'Create Group',
    group: 'Group',
    posttopic: 'Post New Topic (Moderator Posting Mode)',
    addnewtopic: 'Send New Topic',
    send: 'Send',
    save: 'Save',
    cancel: 'Cancel',
    gotogroup: 'Go To Discussion (Participant Mode)',
    nb: 'NB',
    rankeditems: 'Top Five',
    nogos: 'No Go Topics',
    none: 'None specified',
    addto: 'ADD TO: ',
    notbothered: 'Not Bothered',
    created: 'Created',
    yes: 'Yes',
    no: 'No',
    groupaccess: 'Groups to moderate',
    groupname: 'New Group Name',
    nogroupsaddedyet: 'Currently no group access',
    fullyAnonymiseGroup: 'Anonymise Icons and Titles?',
    introvideolink: 'Add link to introduction video for group',
    singleStream: 'Show messages in single stream, rather than by topic',
    globalSwitches: 'Global Settings',
    globalPostingAllowed: 'Posting is allowed.  All users can post messages based on time based restrictions.',
    globalPostingBlocked: 'Posting is stopped globally.  No user will be able to post new messages.'
  },
  es: {
    title: 'Users',
    deletemessage: 'The delete user and user index api routes are restricted to users with the \'admin\ role.',
    groupstitle: 'All Groups',
    groupsmessage: 'Add uncategorised uses to groups.',
    unassignedusers: 'Unassigned Users',
    unassignedmessage: 'Add unassigned users to existing group (with add user button) or create new group by selecting multiple users and clicking create.',
    create: 'Create Group',
    group: 'Group',
    posttopic: 'Post New Topic',
    addnewtopic: 'Send New Topic',
    send: 'Send',
    save: 'Save',
    cancel: 'Cancel',
    gotogroup: 'Go To Discussion',
    nb: 'NB',
    rankeditems: 'Top Five',
    nogos: 'No Go Topics',
    none: 'None specified',
    addto: 'ADD TO: ',
    notbothered: 'Not Bothered',
    created: 'Created',
    yes: 'Yes',
    no: 'No',
    groupaccess: 'Groups to moderate',
    groupname: 'New Group Name',
    nogroupsaddedyet: 'Currently no group access',
    fullyAnonymiseGroup: 'Anonymise Icons and Titles?',
    introvideolink: 'Add link to any introduction video for group',
    singleStream: 'Show messages in single stream, rather than by topic'
  },
  fr: {

  },
  de: {

  }
};



// WEBPACK FOOTER //
// ./client/app/admin/admin.localisations.js